import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";

export const SubscriptionCard = ({
  cardBg,
  title,
  isTotalRevenue,
  list,
  cardVariant,
  revenueAmount,
}) => {
  return (
    <div className={styles.cardContainer} style={{ backgroundColor: cardBg }}>
      <div className={styles.title}>{title}</div>
      <ConditionalRenderer condition={title === "Total Revenue"}>
        <div className={styles.revenue}>€{revenueAmount}</div>
      </ConditionalRenderer>
      <ConditionalRenderer condition={title !== "Total Revenue"}>
        <div className={styles.tagsContainer}>
          {list?.map((item) => {
            const Icon = item?.icon;
            return (
              <ConditionalRenderer condition={item.title}>
                <div
                  className={styles.typeTag}
                  style={{ backgroundColor: item.bgColor }}
                >
                  <ConditionalRenderer condition={Icon}>
                    <Icon height={15} width={15} />
                  </ConditionalRenderer>{" "}
                  {item.title}
                </div>
              </ConditionalRenderer>
            );
          })}
        </div>
      </ConditionalRenderer>
    </div>
  );
};
